var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3825 1.57945L110.698 45.5799C122.662 51.4736 121.42 69.0302 108.747 73.1576L85.9451 80.5842C84.4787 81.0618 83.318 82.2014 82.8071 83.6653L73.6048 110.032C69.269 122.455 52.2343 123.534 46.3849 111.757L1.6257 21.6393C-4.71093 8.88118 8.65581 -4.69021 21.3825 1.57945ZM13.4007 15.7124C12.6966 14.2948 14.1818 12.7869 15.5959 13.4835L104.912 57.4839C106.241 58.1388 106.103 60.0895 104.695 60.5481L81.8927 67.9747C76.5158 69.7259 72.2599 73.9046 70.3866 79.2721L61.1843 105.639C60.7026 107.019 58.8098 107.139 58.1599 105.83L13.4007 15.7124Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/mouse-icon.2878424fa7d78ddaa329e578788585c8.svg";
export { ForwardRef as ReactComponent };